// Mesure d'audience (GA4 + Microsoft Clarity) avec Consent Mode v2 + API de consentement Clarity.
// Aucun script réseau n'est chargé tant que le visiteur n'a pas explicitement accepté.
import { cachedMe } from "@/lib/me";

const KEY = "gu_consent"; // "granted" | "denied" | null
const GA_ID = "G-7T6FL1BN7J";
const CLARITY_ID = "yoxy6ttycm";

let gaLoaded = false;
let clarityLoaded = false;
let defaultsSet = false;

export const getConsent = () => { try { return localStorage.getItem(KEY); } catch (e) { return null; } };

// Le mode créateur, l'admin et le lien créateur ne sont JAMAIS suivis.
export function isExcluded() {
    try {
        const p = window.location.pathname || "";
        if (p.startsWith("/admin") || p.startsWith("/createur")) return true;
        if (cachedMe && cachedMe()?.mode_createur) return true;
    } catch (e) { /* noop */ }
    return false;
}

function gtag() { window.dataLayer.push(arguments); }

// Consent Mode v2 : on déclare le refus PAR DÉFAUT dès le départ (aucune requête réseau).
export function initConsentDefaults() {
    if (defaultsSet) return;
    defaultsSet = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || gtag;
    window.gtag("consent", "default", {
        ad_storage: "denied", ad_user_data: "denied",
        ad_personalization: "denied", analytics_storage: "denied",
        wait_for_update: 500,
    });
}

function loadGA() {
    if (gaLoaded) return;
    gaLoaded = true;
    const s = document.createElement("script");
    s.async = true; // chargement en arrière-plan, jamais bloquant
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    s.onerror = () => { gaLoaded = false; }; // bloqueur de pub : l'app continue exactement pareil
    document.head.appendChild(s);
    window.gtag("js", new Date());
    window.gtag("config", GA_ID, { send_page_view: false, anonymize_ip: true });
}

function loadClarity() {
    if (clarityLoaded) return;
    clarityLoaded = true;
    try {
        (function (c, l, a, r, i, t, y) {
            c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
            t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
            t.onerror = function () { clarityLoaded = false; };
            y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
        })(window, document, "clarity", "script", CLARITY_ID);
    } catch (e) { clarityLoaded = false; }
}

export function activate() {
    if (isExcluded()) return;
    initConsentDefaults();
    loadGA();
    window.gtag("consent", "update", { analytics_storage: "granted" });
    loadClarity();
    try { window.clarity && window.clarity("consent"); } catch (e) { /* noop */ }
    trackPage(window.location.pathname);
}

export function deactivate() {
    initConsentDefaults();
    try { window.gtag && window.gtag("consent", "update", { analytics_storage: "denied" }); } catch (e) { /* noop */ }
    try { window.clarity && window.clarity("consent", false); } catch (e) { /* noop */ }
}

// Appelé au démarrage : pose les défauts (refus) puis, en arrière-plan, réactive si déjà accepté.
export function initAnalytics() {
    initConsentDefaults();
    setTimeout(() => { if (getConsent() === "granted" && !isExcluded()) activate(); }, 0);
}

export function setConsent(choice) {
    try { localStorage.setItem(KEY, choice); } catch (e) { /* noop */ }
    if (choice === "granted") activate(); else deactivate();
}

export function trackPage(path) {
    if (getConsent() !== "granted" || isExcluded()) return;
    try { window.gtag && window.gtag("event", "page_view", { page_path: path }); } catch (e) { /* noop */ }
}
